import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducers';

const select = (state: Store) => state.providers || initialState;

const makeSelectProvidersList = () =>
  createSelector(select, subState => subState.providerList);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);
const makeSelectInactiveCardCountList = () =>
  createSelector(select, subState => subState.inactiveCardCount);
const makeSelectActiveCardCountList = () =>
  createSelector(select, subState => subState.activeCardCount);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectInactiveCardCountList,
  makeSelectActiveCardCountList,
  makeSelectProvidersList,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
};
